import React from "react";

const Form = ({montant, setMontant, puissance, setPuissance, imposable, setImposable, setResultat}) =>
    <div>
        <div className="mb-3"  style={{ marginBottom: "15px" }}>
            <label htmlFor="montant" className="form-label titre-question">1- Montant TTC des travaux en €</label>
            <div className="question">
                <div className="complement">Equipements et installation (se référer au devis que vous devrez fournir lors de votre demande)</div>
                <input type="number" className="form-control" id="montant" value={montant} 
                    onChange={(e) => {
                        let montant = Math.round((Number(e.target.value)+Number.EPSILON)*100)/100
                        if (montant < 0) montant = 0;
                        if (montant === 0) montant = "";
                        // Arrondi à 2 décimales
                        setMontant(montant)
                        // Réinitialisation du résultat
                        setResultat()
                    }}/>
            </div>
        </div>
        <div className="mb-3"  style={{ marginBottom: "15px" }}>
            <label htmlFor="puissance" className="form-label titre-question">2- Puissance de l'installation en kWc</label>
            <div className="question">
                <div className="complement">Attention : la puissance ne peut pas excéder 3kWc</div>
                <input type="number" className="form-control" id="puissance" value={puissance}
                    onChange={(e) => {
                        let puissance = Math.round((Number(e.target.value)+Number.EPSILON)*100)/100
                        if (puissance < 0) puissance = 0;
                        if (puissance === 0) puissance = "";                        
                        // Arrondi à 2 décimales
                        setPuissance(puissance)
                        // Réinitialisation du résultat
                        setResultat()
                    }}/>
            </div>
        </div>
        <div className="mb-3"  style={{ marginBottom: "15px" }}>
            <label className="titre-question">3- Mes informations personnelles</label>
            <div className="question">
                <div className="form-check">
                    <input className="form-check-input" type="radio" name="imposable" id="flexRadioDefault1" value="oui" checked={imposable === "oui"}
                        onChange={(e) => {
                            setImposable(e.target.value)
                            // Réinitialisation du résultat
                            setResultat()
                        }}/>
                    <span className="form-check-label" htmlFor="flexRadioDefault1">
                    Je fais partie d’un foyer fiscal imposable
                    </span>
                </div>
                <div className="form-check">
                    <input className="form-check-input" type="radio" name="imposable" id="flexRadioDefault2" value="non" checked={imposable === "non"}
                        onChange={(e) => {
                            setImposable(e.target.value)
                            // Réinitialisation du résultat
                            setResultat()
                        }}/>
                    <span className="form-check-label" htmlFor="flexRadioDefault2">
                    Je fais partie d’un foyer fiscal non imposable
                    </span>
                </div>
            </div>
        </div>
    </div>

    export default Form